import axios from 'axios';
import lib from '@/lib';

export default class AuctionsModel {
	constructor() {
		this.confirmSellingShow = false;
	}
}
